module.exports = __webpack_public_path__ + "7005ecb5fdd6a58a3fb443683a199461.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/darksky.png
// module id = 256
// module chunks = 1